import useLoaderStore from "@/store/loader.store";
import axios from "axios";
import Cookies from "js-cookie";
import { NavigateOptions } from "next/dist/shared/lib/app-router-context.shared-runtime";

const API = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BASE_URL,
});

API.interceptors.request.use(
  function (config) {
    const token = `Bearer ${Cookies.get("token")}`;
    config.headers.Authorization = token;
    useLoaderStore.getState().setLoading(true);
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
// API.interceptors.response.use(
//   function (response) {
//     // Any status code that lie within the range of 2xx cause this function to trigger
//     // Do something with response data
//     return response;
//   },
//   function (error) {
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     // Do something with response error

//     if (error.response?.status === 401) {
//       Cookies.remove("token");
//       Cookies.remove("sub");
//     }
//     return Promise.reject(error);
//   },
// );

export const setupInterceptors = (
  navigate: (href: string, options?: NavigateOptions) => void,
) => {
  API.interceptors.response.use(
    function (response) {
      useLoaderStore.getState().setLoading(false);
      return response;
    },
    function (error) {
      if (error.response?.status === 401) {
        Cookies.remove("token");
        Cookies.remove("sub");
        navigate("/"); // Use smooth navigation
      }
      useLoaderStore.getState().setLoading(false);
      return Promise.reject(error);
    },
  );
};

export default API;
